import { apiService, handleResponse } from '@/services/apiService';

export class ProductRepository {
    async getProduct(id: number, data: { userId?: number | null }) {
        const response = await apiService.get(`/v1/products/${id}`, { params: data });
        return handleResponse(response);
    }
    async getProductsByIds(data: any) {
        const response = await apiService.post(`/v1/products`, data);
        return handleResponse(response);
    }
    async searchProducts(data: any) {
        const response = await apiService.post(`/v1/products/search`, data);
        return handleResponse(response);
    }
}